import React from 'react';
import { useDemo } from '../../contexts/DemoContext';
import Icon from '../AppIcon';

const DemoModeBanner = () => {
  const { isDemoModeActive, selectedProfile, getSelectedProfileInfo, toggleDemoMode } = useDemo();

  if (!isDemoModeActive) return null;

  const profileInfo = getSelectedProfileInfo();

  return (
    <div className="border-y border-yellow-200 bg-yellow-50/90 backdrop-blur">
      <div className="flex items-center justify-between max-w-7xl mx-auto px-4 sm:px-6 py-3">
        <div className="flex items-center gap-3">
          <Icon name="Info" size={20} className="text-yellow-600" />
          <div>
            <p className="text-sm font-semibold text-yellow-900">
              Demo Mode Active - {profileInfo?.name || 'Demo Profile'}
            </p>
            <p className="text-xs text-yellow-700">
              You are viewing demo data. Your personal data is safe and unchanged.
            </p>
          </div>
        </div>
        <button
          onClick={toggleDemoMode}
          className="px-4 py-2 text-sm font-medium text-yellow-900 bg-yellow-100 hover:bg-yellow-200 rounded-md transition-colors"
        >
          Exit Demo Mode
        </button>
      </div>
    </div>
  );
};

export default DemoModeBanner;

